import { Loader } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

const LazyMembershipPolicy = () => (
  <Loadable
    Loader={
      <div className="w-full h-screen flex justify-center py-24">
        <Loader />
      </div>
    }
    module={() =>
      import(
        /* webpackChunkName: "legal-membership-policy" */ './MembershipPolicy'
      )
    }
  />
);

export default LazyMembershipPolicy;
